/* InputArea组件样式 - Minimal Sci-Fi Capsule Update */
.input-container {
  width: 100%;
  max-width: 860px; /* 稍微放宽一点 */
  margin: 2rem auto 1.5rem auto; /* 居中显示 */
  position: relative;
  z-index: 1000; /* 提升层级，防止花瓣菜单被遮挡 */
  overflow: visible !important;
}

/* 移除旧的 input-header 样式 */
.input-header,
.input-title {
  display: none;
}

.input-area-form {
  width: 100%;
}

/* 胶囊输入栏容器 */
.input-capsule-bar {
  display: flex;
  align-items: flex-end; /* 底部对齐，适应输入框高度变化 */
  /* 配色与模式卡片一致，稍微亮一点 */
  background: var(--input-bg);
  backdrop-filter: blur(12px);
  border: 1px solid var(--input-border); /* 边框色调也调整为蓝色系 */
  border-radius: 40px;
  padding: 16px 20px; /* 增加内边距，使输入框看起来更高大 */

  gap: 16px; /* 增加间距 */
  box-shadow: 
    0 6px 18px rgba(0, 0, 0, 0.08),
    inset 0 1px 1px rgba(255, 255, 255, 0.05);
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  width: 100%;
  position: relative;
  z-index: 100; /* 确保在花瓣菜单之上，且高于其他页面元素 */
  overflow: visible !important; /* 强制允许子元素溢出 */
}

.input-capsule-bar:hover {
  border-color: rgba(26, 115, 232, 0.35);
  box-shadow: 
    0 8px 24px rgba(0, 0, 0, 0.06),
    0 0 15px var(--accent-glow);
  transform: translateY(-1px);
}

.input-capsule-bar:focus-within {
  background: var(--input-focus-bg);
  border-color: var(--accent-color);
  animation: capsule-focus-breath 4s infinite ease-in-out;
}

@keyframes capsule-focus-breath {
  0%, 100% {
    box-shadow: 
      0 0 0 1px var(--accent-color),
      0 4px 16px rgba(26, 115, 232, 0.12);
    transform: translateY(-1px);
  }
  50% {
    box-shadow: 
      0 0 0 1px var(--accent-color),
      0 12px 32px rgba(26, 115, 232, 0.22);
    transform: translateY(-2.5px);
  }
}

/* 通用胶囊图标按钮样式 */
.capsule-icon-btn {
  width: 44px; /* 稍微加宽 */
  height: 56px; /* 高度匹配单行输入框 */
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: var(--input-btn-color); /* 稍微提亮默认颜色 */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 24px; /* 图标加大 */
  padding: 0;
  position: relative;
}

.capsule-icon-btn:hover {
  color: var(--accent-color);
  transform: scale(1.1) translateY(-1.5px);
}

.capsule-icon-btn.has-file {
  color: var(--accent-color);
}

/* 上传指示点 */
.upload-indicator {
  position: absolute;
  top: 10px;
  right: 6px;
  width: 6px;
  height: 6px;
  background-color: var(--accent-color);
  border-radius: 50%;
  box-shadow: 0 0 5px var(--accent-color);
}

/* 已上传图片数量徽标 */
.upload-count-badge {
  position: absolute;
  top: 8px;
  right: 4px;
  min-width: 16px;
  height: 16px;
  background-color: var(--accent-color);
  color: #fff;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  padding: 0 3px;
  box-shadow: 0 0 5px var(--accent-color);
}

/* 输入框样式 */
.input-capsule-textarea {
  flex: 1;
  background: transparent;
  border: none;
  color: var(--text-color);
  font-size: 1.15rem; /* 字体稍微加大，更易阅读 */
  font-family: 'Inter', sans-serif;
  resize: none;
  line-height: 1.6; /* 行高增加 */
  padding: 14px 10px; /* 增加内边距 */
  min-height: 56px; /* 增加最小高度 */
  max-height: 200px;
  overflow-y: auto;
}

/* 输入框滚动条样式优化 */
.input-capsule-textarea::-webkit-scrollbar {
  width: 6px;
}
.input-capsule-textarea::-webkit-scrollbar-track {
  background: transparent;
}
.input-capsule-textarea::-webkit-scrollbar-thumb {
  background-color: var(--hover-color);
  border-radius: 10px;
}
.input-capsule-textarea::-webkit-scrollbar-thumb:hover {
  background-color: var(--light-gray);
}

.input-capsule-textarea:focus {
  outline: none;
}

.input-capsule-textarea::placeholder {
  color: var(--input-placeholder-color);
}

/* 提示词历史与收藏 */
.prompt-history-panel {
  width: 100%;
  margin-top: 10px;
  padding: 0 14px;
}

.prompt-history-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 7px;
  color: var(--input-placeholder-color);
  font-size: 12px;
}

.prompt-history-title {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: var(--text-color);
  font-weight: 600;
}

.prompt-history-title i {
  color: var(--accent-color);
  font-size: 14px;
}

.prompt-history-list {
  display: flex;
  gap: 8px;
  width: 100%;
  padding: 1px 1px 7px;
  overflow-x: auto;
  overscroll-behavior-x: contain;
  scrollbar-width: thin;
  scrollbar-color: var(--input-border) transparent;
}

.prompt-history-list::-webkit-scrollbar {
  height: 4px;
}

.prompt-history-list::-webkit-scrollbar-thumb {
  background: var(--input-border);
  border-radius: 4px;
}

.prompt-history-item {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  max-width: 360px;
  min-height: 34px;
  overflow: hidden;
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: 18px;
  transition: border-color 0.2s ease, background-color 0.2s ease, transform 0.2s ease;
}

.prompt-history-item:hover {
  border-color: var(--accent-color);
  transform: translateY(-1px);
}

.prompt-history-item.is-favorite {
  border-color: rgba(245, 158, 11, 0.5);
}

.prompt-history-text,
.prompt-favorite-btn {
  border: 0;
  background: transparent;
  color: var(--text-color);
  cursor: pointer;
  font: inherit;
}

.prompt-history-text {
  max-width: 310px;
  padding: 7px 5px 7px 13px;
  overflow: hidden;
  font-size: 13px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.prompt-favorite-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  width: 35px;
  flex: 0 0 35px;
  padding: 0;
  color: var(--input-placeholder-color);
  font-size: 16px;
  transition: color 0.2s ease, transform 0.2s ease;
}

.prompt-favorite-btn:hover,
.prompt-history-item.is-favorite .prompt-favorite-btn {
  color: #f59e0b;
}

.prompt-favorite-btn:hover {
  transform: scale(1.12);
}

.prompt-history-text:focus-visible,
.prompt-favorite-btn:focus-visible {
  outline: 2px solid var(--accent-color);
  outline-offset: -2px;
}

.prompt-history-panel.is-disabled {
  opacity: 0.55;
}

.prompt-history-text:disabled,
.prompt-favorite-btn:disabled {
  cursor: not-allowed;
}

/* AI修饰小按钮 */
.ai-enhance-icon-btn {
  color: #a5b4fc;
  font-size: 20px;
  margin-right: 6px;
}

.ai-enhance-icon-btn:hover {
  color: #818cf8;
  transform: scale(1.1) rotate(15deg);
  text-shadow: 0 0 10px #818cf8;
}

/* 提交按钮容器 */
.submit-btn-wrapper {
  position: relative;
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20; /* 确保在最上层 */
  overflow: visible !important; /* 强制允许溢出 */
}

/* 提交按钮 */
.capsule-submit-btn {
  width: 56px;
  height: 56px;
  border-radius: 28px;
  border: none;
  background: linear-gradient(135deg, var(--accent-color) 0%, #3a56d4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 0 4px 10px rgba(79, 109, 245, 0.3);
  overflow: hidden;
  position: relative;
  z-index: 22; /* 比wrapper高，确保可点击 */
}

.capsule-submit-btn:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 6px 15px rgba(79, 109, 245, 0.5);
}

.capsule-submit-btn:active:not(:disabled) {
  transform: scale(0.95);
}

.capsule-submit-btn:disabled {
  cursor: not-allowed;
  background: var(--submit-disabled-bg);
  border: 1px solid var(--submit-disabled-border);
  box-shadow: none;
}

.capsule-submit-btn:disabled .current-mode-icon {
  color: var(--submit-disabled-color);
}

.capsule-submit-btn i.rotating {
  color: white;
  font-size: 20px;
  animation: rotate 1s linear infinite;
}

.current-mode-icon {
  color: white;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 桌面端/移动端图标切换 */
.submit-icon-mobile {
  display: none;
}
.submit-icon-desktop {
  display: block;
}

.upload-icon-mobile {
  display: none;
}

/* 移动端模式切换按钮 (默认隐藏) */
.mobile-mode-toggle {
  display: none;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 花瓣菜单 */
.mode-petal-menu {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200px; /* 增加感应区域，防止鼠标移开时立即消失 */
  height: 200px;
  transform: translate(-50%, -50%);
  pointer-events: none; /* 默认不响应事件 */
  z-index: 15; /* 在按钮之下，但在其他元素之上 */
  border-radius: 50%;
}

.mode-petal-menu.visible {
  pointer-events: auto;
}

.mode-petal-item {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 48px; /* 加大圆盘尺寸 */
  height: 48px;
  border-radius: 50%;
  background: var(--petal-bg); /* 增加不透明度 */
  backdrop-filter: blur(12px);
  border: 1px solid var(--petal-border);
  color: var(--petal-color);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transform: translate(-50%, -50%) scale(0);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  opacity: 0;
  box-shadow: var(--petal-shadow);
  z-index: 16;
  font-size: 20px; /* 加大图标 */
}

.mode-petal-menu.visible .mode-petal-item {
  opacity: 1;
  /* 确保展开后位置正确，并保持缩放 */
  transform: translate(calc(-50% + var(--tx)), calc(-50% + var(--ty))) scale(1);
  transition-delay: var(--delay);
}

.mode-petal-item:hover {
  background: rgba(0, 170, 255, 0.9);
  color: white;
  border-color: rgba(0, 170, 255, 1);
  box-shadow: 0 0 20px rgba(0, 170, 255, 0.6);
  /* 悬停时放大 */
  transform: translate(calc(-50% + var(--tx)), calc(-50% + var(--ty))) scale(1.2);
  z-index: 25; /* 悬停时置顶 */
}

.mode-petal-item.active {
  background: var(--petal-active-bg);
  border-color: var(--petal-active-border);
  color: var(--petal-active-color);
  box-shadow: var(--petal-active-shadow);
}

.mode-name {
  display: none; /* Desktop hidden */
}

/* 多图预览水平行 */
.image-previews-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin: 0 0 0.8rem 1rem;
}

/* 图片预览区域优化 */
.image-preview-container {
  max-width: 130px;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.3);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  position: relative;
  backdrop-filter: blur(5px);
  animation: slideDown 0.3s ease-out;
  display: inline-block;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.image-preview {
  width: 100%;
  height: auto;
  display: block;
  max-height: 120px;
  object-fit: contain;
}

.remove-image-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(4px);
  font-size: 12px;
}

.remove-image-btn:hover {
  background-color: rgba(239, 68, 68, 0.8);
  transform: rotate(90deg);
}

/* 进度条 */
.progress-bar {
  width: 100%;
  height: 2px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  margin-top: 0.5rem;
  overflow: hidden;
  position: relative;
}

.progress-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(90deg, var(--accent-color), #a5b4fc, var(--accent-color));
  background-size: 200% 100%;
  border-radius: 2px;
  animation: loading-progress 1.5s infinite linear;
  width: 30%;
  box-shadow: 0 0 10px var(--accent-color);
}

/* 提示词推荐区域 */
.input-bottom-area {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
  padding: 0 6px;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
}

.suggestions-wrapper {
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
  flex: 1;
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  padding-bottom: 4px;
  /* 隐藏滚动条但保留滚动功能 */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.suggestions-wrapper::-webkit-scrollbar {
  display: none;
}

.suggestion-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 3px 9px;
  font-size: 0.72rem;
  line-height: 1.35;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
  backdrop-filter: blur(5px);
  user-select: none;
  display: block;
  animation: fadeIn 0.5s ease-out;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
  max-width: clamp(140px, 30vw, 340px);
}

.suggestion-card:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(165, 180, 252, 0.4);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.suggestion-card:active {
  transform: translateY(0);
  background: rgba(255, 255, 255, 0.08);
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(5px); }
  to { opacity: 1; transform: translateY(0); }
}

/* 移动端响应式优化 */
@media (max-width: 768px) {
  .input-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 8px 12px calc(14px + env(safe-area-inset-bottom)) 12px !important; /* 向下偏移 6px (原8px)，贴紧手机底边缘，进一步避开对画板的遮挡 */
    background: linear-gradient(to top, rgba(15, 17, 28, 0.98) 85%, rgba(15, 17, 28, 0.8) 95%, rgba(15, 17, 28, 0));
    backdrop-filter: blur(16px);
    box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.6);
    z-index: 1001; /* 确保在最上层 */
  }

  /* 移动端模式切换药丸栏 (模仿 Gemini) */
  .mobile-mode-pills-container {
    display: flex;
    gap: 6px;
    overflow-x: auto;
    padding: 2px 2px 6px 2px;
    margin-bottom: 4px;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    width: 100%;
  }
  
  .mobile-mode-pills-container::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
  
  .mobile-mode-pill {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-size: 11px;
    font-weight: 500;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    flex-shrink: 0;
  }
  
  .mobile-mode-pill i {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
  }
  
  .mobile-mode-pill.active {
    background: linear-gradient(135deg, rgba(0, 170, 255, 0.2), rgba(0, 122, 255, 0.3));
    border-color: rgba(0, 170, 255, 0.8);
    color: #00aaff;
    box-shadow: 0 0 10px rgba(0, 170, 255, 0.25);
    font-weight: 600;
  }

  .mobile-mode-pill.active i {
    color: #00aaff;
  }

  .input-capsule-bar {
    padding: 4px 6px 4px 10px;
    gap: 6px;
    border-radius: 20px;
  }
  
  .mode-icon-hint {
    font-size: 15px;
  }
  
  .capsule-icon-btn {
    width: 30px;
    height: 36px;
    font-size: 17px;
  }
  
  .input-capsule-textarea {
    font-size: 13.5px;
    padding: 8px 2px;
    min-height: 36px;
  }
  
  .capsule-submit-btn {
    width: 36px;
    height: 36px;
    display: flex; /* 保持显示 */
  }
  
  /* 移动端隐藏独立模式切换按钮 */
  .mobile-mode-toggle {
    display: none !important;
  }

  .submit-btn-wrapper {
    width: auto;
    height: 36px;
    gap: 6px;
    position: relative;
    display: flex;
    align-items: center;
    overflow: visible !important;
  }

  .capsule-submit-btn {
    width: 36px;
    height: 36px;
    display: flex; /* 保持显示 */
  }
  
  .submit-icon-desktop {
    display: none;
  }
  
  .submit-icon-mobile {
    display: block;
    font-size: 16px;
  }

  /* 提示词横向排列 (保持和桌面一致，允许横向滑动) */
  .suggestions-wrapper {
    flex-direction: row;
    width: 100%;
    gap: 4px;
    overflow-x: auto;
  }
  
  .suggestion-card {
    width: auto;
    max-width: 78vw;
    font-size: 10.5px;
    padding: 3px 8px;
    text-align: center;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.08);
  }
  
  .input-bottom-area {
    flex-direction: column;
    gap: 6px;
    margin-top: 6px;
  }
  
  .extra-content-wrapper {
    margin-left: 0 !important;
    width: 100%;
    justify-content: flex-end;
  }
}

/* --- 模式切换交互提醒动效 (无文字纯视觉) --- */
/* 桌面端外层光晕动效 */
.submit-btn-wrapper.show-reminder::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 28px; /* 匹配按钮圆角 */
  box-shadow: 0 0 0 0 rgba(0, 170, 255, 0.6);
  animation: wrapper-pulse 2s infinite;
  pointer-events: none;
  z-index: 10;
}

/* 给按钮里的图标加一个轻微的跳动效果，进一步吸引视线 */
.submit-btn-wrapper.show-reminder .submit-icon-desktop,
.mobile-mode-toggle.show-reminder i {
  animation: icon-bounce 2s infinite;
  display: inline-block;
}

@keyframes wrapper-pulse {
  0% { box-shadow: 0 0 0 0 rgba(0, 170, 255, 0.6); }
  70% { box-shadow: 0 0 0 15px rgba(0, 170, 255, 0); }
  100% { box-shadow: 0 0 0 0 rgba(0, 170, 255, 0); }
}

@keyframes icon-bounce {
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-4px); }
  60% { transform: translateY(-2px); }
}

@media (max-width: 768px) {
  /* 移动端不给 wrapper 施加光晕，只给独立的 toggle 按钮施加光晕 */
  .submit-btn-wrapper.show-reminder::before {
    display: none; 
  }
  
  .mobile-mode-toggle.show-reminder {
    animation: wrapper-pulse 2s infinite;
  }
}

/* ========================================================
   LIGHT THEME STYLES - INPUT AREA & BUTTONS (Gemini-inspired)
   ======================================================== */
html[data-theme='light'] .image-preview-container {
  border: 1px solid var(--border-color) !important;
  background: rgba(0, 0, 0, 0.03) !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05) !important;
}

html[data-theme='light'] .remove-image-btn {
  background-color: rgba(255, 255, 255, 0.85) !important;
  color: var(--text-color) !important;
}

html[data-theme='light'] .remove-image-btn:hover {
  background-color: var(--error-color) !important;
  color: white !important;
}

html[data-theme='light'] .suggestion-card {
  background: #f0f4f9 !important;
  border: 1px solid #dadce0 !important;
  color: #5f6368 !important;
}

html[data-theme='light'] .suggestion-card:hover {
  background: #e8f0fe !important;
  border-color: var(--accent-color) !important;
  color: var(--accent-color) !important;
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.1) !important;
}

html[data-theme='light'] .suggestion-card:active {
  background: #d2e3fc !important;
}

html[data-theme='light'] .mobile-mode-pill {
  background: #f0f4f9 !important;
  border: 1px solid #dadce0 !important;
  color: #5f6368 !important;
}

html[data-theme='light'] .mobile-mode-pill i {
  color: #5f6368 !important;
}

html[data-theme='light'] .mobile-mode-pill.active {
  background: #e8f0fe !important;
  border-color: var(--accent-color) !important;
  color: var(--accent-color) !important;
  box-shadow: 0 0 10px var(--accent-glow) !important;
}

html[data-theme='light'] .mobile-mode-pill.active i {
  color: var(--accent-color) !important;
}

/* 亮色模式下激活态生成按钮适配 - 采用优雅柔和的 Gemini 渐变彩色，告别突兀的纯高饱和蓝色 */
html[data-theme='light'] .capsule-submit-btn:not(:disabled) {
  background: linear-gradient(135deg, #4285f4 0%, #9b72cb 50%, #d96570 100%) !important;
  box-shadow: 0 4px 15px rgba(155, 114, 203, 0.25) !important;
}

html[data-theme='light'] .capsule-submit-btn:not(:disabled):hover {
  background: linear-gradient(135deg, #5191f5 0%, #a87fd6 50%, #e07489 100%) !important;
  box-shadow: 0 6px 20px rgba(155, 114, 203, 0.4) !important;
  transform: scale(1.05);
}

html[data-theme='light'] .capsule-submit-btn:not(:disabled):active {
  transform: scale(0.95);
}

/* ==========================================================================
   模式解释说明面板样式 - 现代暗色微弱磨砂 & 亮色优雅适配
   ========================================================================== */
.mode-explanation-panel {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0 0 10px 14px;
  padding: 5px 10px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  width: fit-content;
  max-width: 100%;
  animation: explanation-fade-in 0.35s cubic-bezier(0.25, 0.8, 0.25, 1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 亮色模式适配 */
html[data-theme='light'] .mode-explanation-panel {
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(0, 0, 0, 0.04);
  color: rgba(0, 0, 0, 0.6);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
}

@keyframes explanation-fade-in {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mode-explanation-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
  color: var(--accent-color, #1a73e8);
  background: rgba(26, 115, 232, 0.1);
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  white-space: nowrap;
}

/* 亮色模式下的标签稍微提亮 */
html[data-theme='light'] .mode-explanation-tag {
  background: rgba(26, 115, 232, 0.08);
}

.mode-explanation-tag i {
  font-size: 14px;
}

/* ==========================================================================
   积分消耗胶囊组件（分段选择：免费 / 标准积分 / 深度思考）
   ========================================================================== */

.usage-mode-capsule {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 2px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  box-sizing: border-box;
  gap: 2px;
  user-select: none;
  isolation: isolate;
  transition: border-color 0.22s ease, background 0.22s ease, box-shadow 0.22s ease;
}

.usage-mode-capsule:hover {
  border-color: rgba(255, 255, 255, 0.24);
}

.usage-mode-segment {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-height: 25px;
  padding: 3px 10px;
  border: 1px solid transparent;
  border-radius: 999px;
  background: transparent;
  color: rgba(255, 255, 255, 0.65);
  font: inherit;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  box-sizing: border-box;
  outline: none;
  transition: all 0.22s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.usage-mode-segment i {
  font-size: 12px;
  transition: transform 0.2s ease, color 0.2s ease;
}

.usage-mode-segment:hover:not(.active) {
  color: rgba(255, 255, 255, 0.92);
  background: rgba(255, 255, 255, 0.07);
}

.usage-mode-segment:hover:not(.active) i {
  transform: scale(1.12);
}

/* 激活通用样式 */
.usage-mode-segment.active {
  font-weight: 600;
  cursor: default;
}

/* 激活：免费模式（清新蓝绿色调） */
.usage-mode-segment.active.free-active {
  background: rgba(56, 189, 248, 0.15);
  color: #38bdf8;
  border-color: rgba(56, 189, 248, 0.35);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}

.usage-mode-segment.active.free-active i {
  color: #38bdf8;
}

/* 激活：标准积分模式（经典科技深蓝渐变） */
.usage-mode-segment.active.standard-active {
  background: linear-gradient(100deg, #1d4ed8, #2563eb 52%, #0ea5e9);
  color: #ffffff;
  border-color: rgba(96, 165, 250, 0.4);
  box-shadow: 0 0 12px rgba(37, 99, 235, 0.35);
}

.usage-mode-segment.active.standard-active i {
  color: #ffffff;
}

/* 激活：深度思考模式（位于胶囊最右端，优雅深邃紫蓝渐变与AI智思律动） */
.usage-mode-segment.active.deep-active {
  background: linear-gradient(105deg, #4f46e5 0%, #7c3aed 50%, #9333ea 100%);
  color: #ffffff;
  border-color: rgba(192, 132, 252, 0.45);
  box-shadow: 0 0 14px rgba(124, 58, 237, 0.45), inset 0 0 8px rgba(255, 255, 255, 0.2);
}

.usage-mode-segment.active.deep-active i {
  color: #f5f3ff;
  animation: brain-pulse 2.2s infinite ease-in-out;
}

@keyframes brain-pulse {
  0%, 100% {
    transform: scale(1);
    filter: drop-shadow(0 0 0 transparent);
  }
  50% {
    transform: scale(1.18);
    filter: drop-shadow(0 0 5px rgba(233, 213, 255, 0.85));
  }
}

/* 深度思考批注标签 */
.usage-mode-segment .deep-think-tag {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border-radius: 999px;
  background: rgba(147, 51, 234, 0.22);
  border: 1px solid rgba(192, 132, 252, 0.3);
  color: #e9d5ff;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.25;
  letter-spacing: 0.02em;
  transition: all 0.2s ease;
}

.usage-mode-segment.active.deep-active .deep-think-tag {
  background: rgba(255, 255, 255, 0.22);
  border-color: rgba(255, 255, 255, 0.45);
  color: #ffffff;
}

/* 等待时间更长提示文本 */
.usage-mode-segment .deep-think-wait-hint {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.52);
  font-weight: 400;
  letter-spacing: -0.01em;
  margin-left: -1px;
  transition: color 0.2s ease;
}

.usage-mode-segment.active.deep-active .deep-think-wait-hint {
  color: rgba(255, 255, 255, 0.88);
}

/* 提交按钮深度思考高亮光效 */
.capsule-submit-btn.deep-thinking-submit {
  background: linear-gradient(135deg, #4f46e5, #7c3aed 55%, #9333ea);
  box-shadow: 0 0 14px rgba(124, 58, 237, 0.45);
}

.capsule-submit-btn.deep-thinking-submit:hover:not(:disabled) {
  box-shadow: 0 0 20px rgba(124, 58, 237, 0.68);
  transform: scale(1.03);
}

/* 亮色模式适配 (Light Theme) */
html[data-theme='light'] .usage-mode-capsule {
  background: rgba(148, 163, 184, 0.12);
  border-color: rgba(71, 85, 105, 0.18);
}

html[data-theme='light'] .usage-mode-capsule:hover {
  border-color: rgba(71, 85, 105, 0.32);
}

html[data-theme='light'] .usage-mode-segment {
  color: #64748b;
}

html[data-theme='light'] .usage-mode-segment:hover:not(.active) {
  color: #0f172a;
  background: rgba(0, 0, 0, 0.05);
}

html[data-theme='light'] .usage-mode-segment.active.free-active {
  background: rgba(2, 132, 199, 0.12);
  color: #0284c7;
  border-color: rgba(2, 132, 199, 0.35);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

html[data-theme='light'] .usage-mode-segment.active.standard-active {
  background: linear-gradient(100deg, #2563eb, #3b82f6 52%, #0284c7);
  color: #ffffff;
  border-color: rgba(37, 99, 235, 0.45);
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.28);
}

html[data-theme='light'] .usage-mode-segment.active.deep-active {
  background: linear-gradient(100deg, #6b21a8, #7c3aed 48%, #4f46e5);
  color: #ffffff;
  border-color: rgba(124, 58, 237, 0.45);
  box-shadow: 0 2px 10px rgba(124, 58, 237, 0.32);
}

html[data-theme='light'] .usage-mode-segment .deep-think-tag {
  background: rgba(124, 58, 237, 0.1);
  border-color: rgba(124, 58, 237, 0.25);
  color: #6d28d9;
}

html[data-theme='light'] .usage-mode-segment.active.deep-active .deep-think-tag {
  background: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.45);
  color: #ffffff;
}

html[data-theme='light'] .usage-mode-segment .deep-think-wait-hint {
  color: #94a3b8;
}

html[data-theme='light'] .usage-mode-segment.active.deep-active .deep-think-wait-hint {
  color: rgba(255, 255, 255, 0.9);
}

html[data-theme='light'] .capsule-submit-btn.deep-thinking-submit {
  background: linear-gradient(135deg, #6d28d9, #7c3aed 55%, #4f46e5);
  box-shadow: 0 2px 12px rgba(109, 40, 217, 0.35);
}

.mode-explanation-divider {
  width: 1px;
  height: 10px;
  background-color: rgba(255, 255, 255, 0.15);
  margin: 0 2px;
}

html[data-theme='light'] .mode-explanation-divider {
  background-color: rgba(0, 0, 0, 0.1);
}

.mode-explanation-desc {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: 0 1 auto;
  min-width: 0;
  line-height: 1.4;
}

.mode-explanation-desc i {
  font-size: 14px;
  color: var(--accent-color, #1a73e8);
  opacity: 0.8;
}

.mode-explanation-desc-title {
  font-weight: 600;
  color: rgba(255, 255, 255, 0.75);
  white-space: nowrap;
  margin-right: 4px;
}

html[data-theme='light'] .mode-explanation-desc-title {
  color: rgba(0, 0, 0, 0.75);
}

.mode-explanation-desc-text {
  color: rgba(255, 255, 255, 0.55);
}

html[data-theme='light'] .mode-explanation-desc-text {
  color: rgba(0, 0, 0, 0.55);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .mode-explanation-panel {
    padding: 4px 8px;
    font-size: 11px;
    border-radius: 14px;
    gap: 5px;
    margin: 0 4px 8px;
    width: fit-content;
    box-sizing: border-box;
  }

  .mode-explanation-tag {
    font-size: 11px;
    padding: 2px 8px;
  }

  .usage-mode-capsule {
    padding: 1px;
    gap: 1px;
    max-width: 100%;
  }

  .usage-mode-segment {
    min-height: 22px;
    padding: 2px 7px;
    font-size: 10px;
    gap: 3px;
  }

  .usage-mode-segment i {
    font-size: 11px;
  }

  .usage-mode-segment .deep-think-tag {
    font-size: 9px;
    padding: 0 4px;
  }

  .usage-mode-segment .deep-think-wait-hint {
    font-size: 9px;
  }

  @media (max-width: 480px) {
    .usage-mode-segment .deep-think-wait-hint {
      display: none;
    }
  }

  .usage-mode-switch {
    width: 110px;
    min-height: 24px;
    padding-right: 26px;
    padding-left: 26px;
  }

  .usage-mode-label {
    font-size: 11px;
  }

  .usage-mode-knob {
    top: 3px;
    width: 16px;
    height: 16px;
    font-size: 9px;
  }

  .usage-mode-switch.paid-active .usage-mode-knob {
    left: calc(100% - 19px);
  }

  .mode-explanation-divider {
    display: none; /* 移动端用自然折行排列 */
  }

  .mode-explanation-desc {
    min-width: 100%;
    margin-top: 2px;
    align-items: flex-start;
  }
}

/* Gemini-inspired mobile composer */
@media (max-width: 768px) {
  .input-container {
    position: fixed !important;
    right: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    width: 100% !important;
    max-width: none !important;
    margin: 0 !important;
    padding: 22px 16px calc(12px + env(safe-area-inset-bottom)) !important;
    overflow: visible !important;
    background: linear-gradient(to top, var(--primary-color, #212121) 58%, transparent) !important;
    box-shadow: none !important;
    backdrop-filter: none !important;
    z-index: 1001 !important;
  }

  .input-area-form {
    width: 100%;
    max-width: 680px;
    margin: 0 auto;
  }

  .mobile-mode-pills-container,
  .input-bottom-area {
    display: none !important;
  }

  .image-previews-row {
    flex-wrap: nowrap;
    max-width: 100%;
    margin: 0 0 8px !important;
    padding: 0 8px;
    overflow-x: auto;
  }

  .image-preview-container {
    flex: 0 0 auto;
    max-width: 92px;
    border-radius: 14px;
  }

  .input-capsule-bar {
    align-items: center !important;
    min-height: 64px;
    padding: 6px 8px !important;
    gap: 4px !important;
    background: rgba(34, 37, 45, 0.96) !important;
    border: 1px solid rgba(255, 255, 255, 0.08) !important;
    border-radius: 34px !important;
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.24) !important;
    backdrop-filter: blur(18px) saturate(150%);
    -webkit-backdrop-filter: blur(18px) saturate(150%);
  }

  .input-capsule-bar:hover,
  .input-capsule-bar:focus-within {
    transform: none !important;
    animation: none !important;
  }

  .capsule-icon-btn {
    width: 48px !important;
    height: 48px !important;
    border-radius: 50%;
    color: var(--text-color);
    font-size: 27px !important;
  }

  .upload-icon-desktop {
    display: none;
  }

  .upload-icon-mobile {
    display: block;
  }

  .input-capsule-textarea {
    min-width: 0;
    min-height: 48px !important;
    max-height: 128px;
    padding: 12px 4px !important;
    color: var(--text-color);
    font-size: 16px !important;
    line-height: 24px;
  }

  .prompt-history-panel {
    margin-top: 8px;
    padding: 0 4px;
  }

  .prompt-history-header {
    margin: 0 5px 5px;
    font-size: 11px;
  }

  .prompt-history-item {
    max-width: min(78vw, 320px);
    min-height: 32px;
  }

  .prompt-history-text {
    max-width: min(66vw, 270px);
    padding-top: 6px;
    padding-bottom: 6px;
    font-size: 12px;
  }

  .ai-enhance-icon-btn {
    width: 40px !important;
    margin: 0;
    font-size: 19px !important;
  }

  .submit-btn-wrapper {
    width: 48px !important;
    height: 48px !important;
    gap: 0 !important;
  }

  .capsule-submit-btn {
    width: 44px !important;
    height: 44px !important;
    border-radius: 50% !important;
    background: var(--accent-color) !important;
    border: 0 !important;
    box-shadow: none !important;
  }

  .capsule-submit-btn:disabled {
    background: rgba(255, 255, 255, 0.12) !important;
  }

  .submit-icon-mobile {
    display: block;
    color: #fff;
    font-size: 23px !important;
    font-weight: 500;
  }

  .capsule-submit-btn:disabled .submit-icon-mobile {
    color: rgba(255, 255, 255, 0.35);
  }

  html[data-theme='light'] .input-container {
    background: linear-gradient(to top, #fff 58%, transparent) !important;
  }

  html[data-theme='light'] .input-capsule-bar {
    background: rgba(255, 255, 255, 0.98) !important;
    border-color: #e2e5e9 !important;
    box-shadow: 0 12px 34px rgba(60, 64, 67, 0.14) !important;
  }

  html[data-theme='light'] .capsule-icon-btn {
    color: #202124;
  }

  html[data-theme='light'] .capsule-submit-btn:disabled {
    background: #e3e5e8 !important;
  }

  html[data-theme='light'] .capsule-submit-btn:disabled .submit-icon-mobile {
    color: #8a8d91;
  }
}
